module.exports = __webpack_public_path__ + "img/img_card_error_01@2x.12396f53.png";